export const boundingBoxFromCollection = (collection) => {
  const {minLat, maxLat, minLon, maxLon} = collection.reduce((acc, elt)=>{
    [
      ["minLat", "latitude", -1],
      ["maxLat", "latitude", 1],
      ["minLon", "longitude", -1],
      ["maxLon", "longitude", 1]
    ].forEach(([field, column, sign])=>{
      if ( ! acc[field] ) {
        acc[field] = elt[column]
      } else if ( sign * acc[field] < sign * elt[column] ) {
        acc[field] = elt[column]
      }
    })
    return acc
  }, { minLat: null, maxLat: null, minLon: null, maxLon: null })
  return [ [minLon, minLat] , [maxLon, maxLat] ]
}
export const dataPointToGeojson = (d) => ({
  type: 'FeatureCollection',
  features: d.map((elt)=>(
    {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [elt.longitude, elt.latitude]
      },
      properties: elt
    }
  ))
})
export const dataLineToGeojson = (d) => ({
  type: 'FeatureCollection',
  features: d.map((elt)=>(
    {
      type: 'Feature',
      geometry: {
        type: 'LineString',
        coordinates: elt.locations.map((loc)=>([loc.longitude, loc.latitude]))
      },
      properties: elt
    }
  ))
})